define(function(require) {
    // GEO09E17_ARRND layer definition config
    return {
        LAYER_ID : "GEO09E17_ARRND",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_ARRND", NAME : "Code de l'arrondissement", DATA_TYPE : "STRING"},
            {ID : "NOM_ARRND", NAME : "Nom de l'arrondissement", DATA_TYPE : "STRING"},
            {ID : "NOM_MUNCP", NAME : "Nom de la municipalité", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Arrondissement",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(56,177,106,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 3
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    COLOR : "rgba(48,177,77,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Arrondissement",
            FEATURE_ID_DATACOLUMN : "CD_ARRND",
            FEATURE_NAME_DATACOLUMN : "NOM_ARRND",
            DATATIP_DATACOLUMNS : ["CD_ARRND", "NOM_ARRND", "NOM_MUNCP"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_ARRND", "NOM_ARRND", "NOM_MUNCP"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_ARRND", "NOM_ARRND", "NOM_MUNCP"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_ARRND", "NOM_ARRND", "NOM_MUNCP"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_ARRND",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
    };
});
